
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/data-log.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-flow-components-data-log-demo-data-log","docs-flow-components-data-log-demo-real"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/flow-components/data-log.md?type=demo')
};